import React from 'react';
import { DateRangePicker } from 'react-bootstrap-daterangepicker';
import type { Props as ReactBootstrapDateRangePickerProps } from 'react-bootstrap-daterangepicker';

export type DateRangePickerWithChildrenProps = ReactBootstrapDateRangePickerProps & {
  children: React.ReactElement;
};

export const DateRangePickerWithChildren = DateRangePicker as unknown as React.ComponentType<DateRangePickerWithChildrenProps>;

export default DateRangePickerWithChildren;
